export class AssetTracking{
    AssetId!: number;
    ActionId!: number;
    AssetViewSourceId!: number;
}

export enum Actions{
    View=1,
    Download = 2
}
export enum AssetViewSources{
    DocumentCenter=1,
    RAIReferenceLink = 2,
    EmailLink = 3,
    StudyStat = 4
}